import React, { useState } from "react";
import { MdCurrencyRupee } from "react-icons/md";
import { HiBanknotes } from "react-icons/hi2";

const RRMerchantInfo = ({ dataItem }) => {
    
  return (
    <div className="rr-merch-info-container">
      <div className="recon-left-section-new">
        <div className="recon-left-section-2">
          <div className="recon-new-section">
            <div className="recon-data-icon-box">
              <p className="recon-heading-new">Amount Paid</p>
            </div>
            <div className="recon-data-icon-box">
              <p className="recon-sub-heading-new">
                ₹{dataItem[0].amountPaid.toFixed(2)}
              </p>
              <div className="recon-icon-div">
                <MdCurrencyRupee
                  style={{
                    width: "1rem",
                    height: "1rem",
                    color: "#1f75cb",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="recon-new-section">
            <div className="recon-data-icon-box">
              <p className="recon-heading-new">Amount Unpaid</p>
            </div>
            <div className="recon-data-icon-box">
              <p className="recon-sub-heading-new">
                {" "}
                ₹{dataItem[0].amountToBePaid.toFixed(2)}{" "}
              </p>
              <div className="recon-icon-div">
                <MdCurrencyRupee
                  style={{
                    width: "1rem",
                    height: "1rem",
                    color: "#1f75cb",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="recon-new-section">
            <div className="recon-data-icon-box">
              <p className="recon-heading-new">Chargeback Initiated</p>
            </div>
            <div className="recon-data-icon-box">
              <p className="recon-sub-heading-new"> ₹{0} </p>
              <div className="icon-div">
                <HiBanknotes
                  style={{
                    width: "1rem",
                    height: "1rem",
                    color: "#1f75cb",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RRMerchantInfo;
